import React from 'react';


function Container({ className, children }) {


    return (
        <div className="container">
            {children}
        </div>
    );
}

export default Container;
